import UITag from 'UIComponents/tag/UITag';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getSLATagColorFromStatus } from 'conversations-thread-data/tickets/public/operators';
import { getColorHashForSLAIconFromStatus } from '../operators/getColorHashForSLAIconFromStatus';
import SLADueDate from './SLADueDate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActiveSLAAlert = ({
  activeSLA
}) => {
  const tagColor = getSLATagColorFromStatus(activeSLA.status);
  const iconColor = getColorHashForSLAIconFromStatus(activeSLA.status);
  return /*#__PURE__*/_jsxs(UITag, {
    use: tagColor,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "time",
      color: iconColor,
      className: "m-right-1"
    }), /*#__PURE__*/_jsx(SLADueDate, {
      slaCategory: activeSLA.category,
      dueDate: activeSLA.dueDate
    })]
  });
};
ActiveSLAAlert.displayName = 'ActiveSLAAlert';
export default ActiveSLAAlert;